"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationHelper_1 = require("./ValidationHelper");
function Regexp(value) {
    return function (target, propertyKey, parameterIndex) {
        var regexValidator = function (fieldValue) {
            if (!value.test(fieldValue)) {
                return "Value must match regular expression " + value;
            }
            return null;
        };
        ValidationHelper_1.addValidationRule(target, parameterIndex, regexValidator);
    };
}
exports.Regexp = Regexp;
